var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa-solid fa-person-walking-luggage"}),_vm._v(" "+_vm._s(_vm.distance)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }